// For displaying a user item
// for displaying the name, fullName is used in general
// first- and lastName are used for displaying initials
import { gql } from 'apollo-angular';
import {
  secondFactorMinimalFragment,
  securityQuestionMinimalFragment,
  userMinimalFragment,
} from '../minimal.fragments';

export const userItemFragment = gql`
  fragment UserItem on User {
    id
    title
    fullName
    firstName
    insertion
    lastName
    email
    secondaryEmail
    customSettings
    portfolioEmailFrequency
    workspaceEmailFrequency
    hasValidPin
    preferredLanguage
    big
    isOnboarded
    isTrusted
    verifiedBig
    isMe
    canUseBetaFeatures
    importantNotices {
      id
      text
      application
    }

    createdAt
  }
`;

export const userWithMinimalSecondFactorFragment = gql`
  fragment UserWithMinimalSecondFactor on User {
    ...UserMinimal

    secondFactor {
      ...SecondFactorMinimal
      securityQuestions {
        ...SecurityQuestionMinimal
      }
    }
  }
  ${userMinimalFragment}
  ${secondFactorMinimalFragment}
  ${securityQuestionMinimalFragment}
`;
